import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps
} from '@mui/material'
import { PowerSource } from '../types'
import { useTranslation } from 'react-i18next'
import { ReactNode } from 'react'

export interface GeneratorPowerSourceSelectProps extends Omit<
  SelectProps<PowerSource>,
  'value' | 'onSelect'
> {
  value?: PowerSource | null
  helperText?: string
  onSelect?: (value: PowerSource) => void
}

export default function GeneratorPowerSourceSelect({
  value,
  helperText,
  onSelect,
  onChange,
  fullWidth,
  error,
  ...props
}: GeneratorPowerSourceSelectProps) {
  const { t } = useTranslation('generator')

  const options: PowerSource[] = [PowerSource.DIESEL, PowerSource.GASOLINE, PowerSource.GAS]

  function handleChange(event: SelectChangeEvent<PowerSource>, child: ReactNode) {
    onChange?.(event, child)
    onSelect?.(event.target.value as PowerSource)
  }

  return (
    <FormControl fullWidth={fullWidth} error={error}>
      <InputLabel>{t('powerSource')}</InputLabel>
      <Select
        {...props}
        label={t('powerSource')}
        value={value || ''}
        error={error}
        onChange={handleChange}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {t(option)}
          </MenuItem>
        ))}
      </Select>

      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  )
}
